import React, { Component } from "react";
import { Form, Input, Checkbox, Button, Divider, message } from "antd";
import styles from "../index.module.less";
import { inject, observer } from "mobx-react";
import co from "co";
import { checkArticleBalance } from "services/options";

const FormItem = Form.Item;

@Form.create({
	onFieldsChange(props, changedFields) {
		props.onFieldsChange(changedFields);
	},
	mapPropsToFields(props) {		
		return props.fields;
	}
})
@observer
class UltraSpinnableArticleForm extends Component {
	render() {
		const balanceText = <span><b>Balance:</b> {this.props.balance}</span>;
		return (
			<Form layout="vertical" className={styles.rxform}>
				<FormItem label="Username">
					{this.props.form.getFieldDecorator("ultraSpinnableArticle.username")(
						<Input type="text" />
					)}
				</FormItem>
				<FormItem label="Password">
					{this.props.form.getFieldDecorator("ultraSpinnableArticle.password")(
						<Input type="text" />
					)}
				</FormItem>
				<FormItem label="API Key">
					{this.props.form.getFieldDecorator("ultraSpinnableArticle.apiKey")(
						<Input type="text" />
					)}
				</FormItem>
				<FormItem>
					{this.props.form.getFieldDecorator("ultraSpinnableArticle.premium", {
						valuePropName: "checked"
					})(<Checkbox>Premium</Checkbox>)}
				</FormItem>
				<FormItem>
					{this.props.form.getFieldDecorator("ultraSpinnableArticle.minis", {
						valuePropName: "checked"
					})(<Checkbox>Mini</Checkbox>)}
				</FormItem>
				<FormItem>
					{this.props.form.getFieldDecorator(
						"ultraSpinnableArticle.nichePacks",
						{
							valuePropName: "checked"
						}
					)(<Checkbox>Niche Packs</Checkbox>)}
				</FormItem>
				<FormItem>
					{this.props.form.getFieldDecorator(
						"ultraSpinnableArticle.spendCredits",
						{
							valuePropName: "checked"
						}
					)(<Checkbox>Spend Money on Marketplace</Checkbox>)}
				</FormItem>
				<FormItem>
					<Button type="primary" onClick={this.props.checkBalance} loading={this.props.checking}>Check Balance</Button>
				</FormItem>
				<Divider type="horizontal" />
				{balanceText}				
			</Form>
		);
	}
}

@inject("rootStore")
@observer
class UltraSpinnableArticle extends Component {
	constructor(props) {
		super(props);
		this.state = {
			checking: false,
			result: ""
		}
	}

	checkBalance = () => {
		const {
			rootStore: { optionsStore }
		} = this.props;		
		
		const options = optionsStore.stateForm;
		const username = options.ultraSpinnableArticle.username ? options.ultraSpinnableArticle.username.value : "";		
		const password = options.ultraSpinnableArticle.password ? options.ultraSpinnableArticle.password.value : "";				
		const apiKey = options.ultraSpinnableArticle.apiKey ? options.ultraSpinnableArticle.apiKey.value : "";				

		co (function*() {
			this.setState({
				checking: true
			})

			const response = yield checkArticleBalance({
				articleSource: "UltraSpinnableArticle",
				inputInfo: JSON.stringify({
					username: username,
					password: password,
					apiKey: apiKey,
					premium: false,
					minis: false,
					nichePacks: false,
					spendCredits: false
				})
			})

			this.setState({
				checking: false
			})

			if (!response) {
				message.error("Failed to check Ultra Spinnable Article balance. Unknown error.");
				return;
			}

			if (response.error) {
				message.error(response.error.message);
				return;
			}

			this.setState({
				balance: response.balance
			})
		}.bind(this))
	}

	onFieldsChange = changedFields => {
		const {
			rootStore: { optionsStore }
		} = this.props;

		optionsStore.formChanged(changedFields);
	};
	mapPropsToFields = () => {
		const {
			rootStore: { optionsStore }
		} = this.props;

		const options = optionsStore.stateForm;
		
		return {
			ultraSpinnableArticle: {
				username: Form.createFormField(options.ultraSpinnableArticle.username),
				password: Form.createFormField(options.ultraSpinnableArticle.password),
				apiKey: Form.createFormField(options.ultraSpinnableArticle.apiKey),
				premium: Form.createFormField(options.ultraSpinnableArticle.premium),
				minis: Form.createFormField(options.ultraSpinnableArticle.minis),
				nichePacks: Form.createFormField(
					options.ultraSpinnableArticle.nichePacks
				),
				spendCredits: Form.createFormField(
					options.ultraSpinnableArticle.spendCredits
				)
			}
		};
	};
	render() {
		return (
			<UltraSpinnableArticleForm
				fields={this.mapPropsToFields()}
				onFieldsChange={this.onFieldsChange}
				checking={this.state.checking}
				balance={this.state.balance}
				checkBalance={this.checkBalance}
			/>
		);
	}
}

export default UltraSpinnableArticle;
